/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AllTagsDto } from '../models/all-tags-dto';
import { TagGroup } from '../models/tag-group';

@Injectable({ providedIn: 'root' })
export class TagsControllerService extends DataBaseService {

  /**
   * Path part for operation tagsControllerGetTags
   */
  static readonly TagsControllerGetTagsPath = '/v1/tags/{entityId}/all';

  /**
   * Get all tags under data query
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTags()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTags$Response(params: {
    entityId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<AllTagsDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TagsControllerService.TagsControllerGetTagsPath, 'get');
    if (params) {
      rb.path('entityId', params.entityId, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AllTagsDto>>;
      })
    );
  }
  /**
   * Get all tags under data query
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTags$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTags(params: {
    entityId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<AllTagsDto>> {

    return this.getTags$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AllTagsDto>>) => r.body as Array<AllTagsDto>)
    );
  }

  /**
   * Path part for operation tagsControllerGetTagGroups
   */
  static readonly TagsControllerGetTagGroupsPath = '/v1/tags/{entityId}/groups';

  /**
   * Get tag groups
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTagGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTagGroups$Response(params: {
    entityId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<TagGroup>>> {

    const rb = new RequestBuilder(this.rootUrl, TagsControllerService.TagsControllerGetTagGroupsPath, 'get');
    if (params) {
      rb.path('entityId', params.entityId, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TagGroup>>;
      })
    );
  }
  /**
   * Get tag groups
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTagGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTagGroups(params: {
    entityId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<TagGroup>> {

    return this.getTagGroups$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TagGroup>>) => r.body as Array<TagGroup>)
    );
  }

}
